// Lib
import React from 'react';

// Analytics
import { sendAmplitudeEvent } from '../../../../../../../analytics/amplitudeService';

// Components
import AiButton from '../components/AiButton';
import AiModeHeading from '../components/AiModeHeading';
import AiModeHeaderSection from '../components/AiModeHeader';
import AiListButton, { AiListButtonTypes } from '../components/AiListButton';

// Types
import {
    AiPopupTransitionDirection,
    AiPromptMode,
    isIdeaPromptHistory,
    AiLocalAiConversation,
    AiHistoryEntry,
    UseAiToolState,
} from '../../state/aiToolStateTypes';

// Constants
import { CONVERSATION_HISTORY_LIMIT } from '../../state/aiToolStateConstants';
import { EVENT_TYPE_NAMES } from '../../../../../../../../common/analytics/amplitudeEventTypesUtil';

// Styles
import './AiAssistantPopupConversationHistory.scss';

const getPromptButtonTitle = (conversation: AiLocalAiConversation): string => {
    if (conversation.title) return conversation.title;

    const results = conversation.results;
    const firstPrompt = results.find(isIdeaPromptHistory) as AiHistoryEntry;
    if (firstPrompt?.text) return firstPrompt.text;

    return 'Untitled';
};

const AiAssistantPopupConversationHistory = ({
    currentConversationId,
    conversations,
    setCurrentConversationId,
    selectNewConversation,
    setMode,
    setReturnMode,
    setTransitionDirection,
}: UseAiToolState): React.ReactElement => {
    const allConversations = Object.values(conversations);

    const conversationHistoryEntries = allConversations
        .filter((conversation, index) => {
            if (index === 0 && conversation.results.length === 0) return false;
            return true;
        })
        .slice(0, CONVERSATION_HISTORY_LIMIT);

    const onClickConversation = (conversation: AiLocalAiConversation) => () => {
        sendAmplitudeEvent({ eventType: EVENT_TYPE_NAMES.SELECTED_AI_HISTORY_ENTRY });

        setTransitionDirection(AiPopupTransitionDirection.UP);
        setMode(AiPromptMode.PROMPTS);
        setCurrentConversationId(conversation._id);
    };

    const onBack = () => {
        setTransitionDirection(AiPopupTransitionDirection.DOWN);
        setMode(AiPromptMode.PROMPTS);
        setReturnMode(AiPromptMode.PROMPTS);
        selectNewConversation();
    };

    return (
        <div className="assistant-popup-section AiAssistantPopupConversationHistory">
            <AiModeHeaderSection>
                <AiButton className="back-button" iconName="ai-back" onClick={onBack}>
                    Back
                </AiButton>
            </AiModeHeaderSection>

            <AiModeHeading>History</AiModeHeading>

            <ul className="AiButtonList">
                {conversationHistoryEntries.map((conversation) => (
                    <li key={conversation._id}>
                        <AiListButton
                            buttonType={AiListButtonTypes.ADVANCE}
                            active={conversation._id === currentConversationId}
                            onClick={onClickConversation(conversation)}
                        >
                            {getPromptButtonTitle(conversation)}
                        </AiListButton>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default AiAssistantPopupConversationHistory;
